module.exports = __webpack_public_path__ + "media/images/minec-2333cc47f160654943531e1fac154149.png";